import clsx from 'clsx';

export const richTextParserClasses = clsx(
  'max-w-full w-full leading-relaxed space-y-4 text-primary',
  '[&_h1]:text-xl [&_h1]:font-semibold [&_h2]:text-lg [&_h2]:font-semibold',
  '[&_p]:mb-2',
  '[&_ul]:list-disc [&_ul]:pl-6 [&_li]:mb-1',
  '[&_ol]:list-decimal [&_ol]:pl-6',
  '[&_pre]:bg-gray-100 [&_pre]:rounded-md [&_pre]:p-4 [&_pre]:overflow-x-auto [&_pre]:whitespace-pre-wrap [&_pre]:text-sm',
  '[&_code]:bg-gray-100 [&_code]:text-pink-600 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded-sm [&_code]:text-sm',
  '[&_mark]:bg-yellow-200 [&_mark]:text-gray-900 [&_mark]:px-1',
  '[&_a]:text-main-blue [&_a]:underline hover:[&_a]:text-blue-800',
  '[&_img]:rounded-lg',
);

interface RichTextViewerProps {
  text?: string;
  className?: string;
}

const RichTextViewer: React.FC<RichTextViewerProps> = ({ text = '', className }) => (
  <div className={clsx(richTextParserClasses, className)} dangerouslySetInnerHTML={{ __html: text }} />
);

export default RichTextViewer;
